export default __webpack_public_path__ + "locales/sr-Latn-RS/DeleteThirdPartyDialog.json?hash=029e4c556dd2e4369e1ce7debaf22397";